module.exports = __webpack_public_path__ + "b4dcf7c8669258bbb78d7f2d856352b6.png";